import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import action from "./action.json";
import addCustomer from "./add-customer.json";
import address from "./address.json";
import cancellation from "./cancellation.json";
import component from "./component.json";
import corporate from "./corporate.json";
import documents from "./documents.json";
import electricityPrice from "./electricity-price.json";
import error from "./error.json";
import form from "./form.json";
import header from "./header.json";
import layout from "./layout.json";
import login from "./login.json";
import maintenance from "./maintenance.json";
import notifications from "./notifications.json";
import service from "./service.json";
import supportCases from "./support-cases.json";
import term from "./term.json";
import unit from "./unit.json";

const shared = {
  ...getI18nJsonProp(action, "shared"),
  ...getI18nJsonProp(addCustomer, "shared"),
  ...getI18nJsonProp(address, "shared"),
  ...getI18nJsonProp(cancellation, "shared"),
  ...getI18nJsonProp(component, "shared"),
  ...getI18nJsonProp(corporate, "shared"),
  ...getI18nJsonProp(documents, "shared"),
  ...getI18nJsonProp(electricityPrice, "shared"),
  ...getI18nJsonProp(error, "shared"),
  ...getI18nJsonProp(form, "shared"),
  ...getI18nJsonProp(header, "shared"),
  ...getI18nJsonProp(layout, "shared"),
  ...getI18nJsonProp(login, "shared"),
  ...getI18nJsonProp(maintenance, "shared"),
  ...getI18nJsonProp(notifications, "shared"),
  ...getI18nJsonProp(service, "shared"),
  ...getI18nJsonProp(supportCases, "shared"),
  ...getI18nJsonProp(term, "shared"),
  ...getI18nJsonProp(unit, "shared"),
};

export default shared;
